import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default function UserLineTypeLinks({ sysUser }) {
  const [loading, setLoading] = useState(false);
  const [notLinkedLineType, setNotLinkedLineType] = useState();
  const [linkedLineType, setLinkedLineType] = useState();

  const requestUnlinkedLineTypes = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/User/UserLineType_LineTypesNotAssigned?idUser=${sysUser.idUser}`;
    axios.get(url).then((response) => {
      setNotLinkedLineType(response.data);
    });
  }, [sysUser.idUser]);

  const requestLinkedLineTypes = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/User/UserLineType_LineTypesAssigned?idUser=${sysUser.idUser}`;
    axios.get(url).then((response) => {
      setLinkedLineType(response.data);
    });
  }, [sysUser.idUser]);

  useEffect(() => {
    requestUnlinkedLineTypes();
    requestLinkedLineTypes();
  }, [requestLinkedLineTypes, requestUnlinkedLineTypes]);

  const onRowSelect = useCallback(
    (row, isSelected) => {
      const data = {
        IdLineType: row.idLineType,
        IdUser: sysUser.idUser,
      };

      if (isSelected) {
        setLoading(true);

        const url = `${process.env.REACT_APP_API2_URL}/User/UserLineType_Add`;
        axios.post(url, data).then((response) => {
          if (response.data === 0) {
            setLoading(false);
            requestUnlinkedLineTypes();
            requestLinkedLineTypes();
          }
        });
      }
    },
    [requestLinkedLineTypes, requestUnlinkedLineTypes, sysUser.idUser]
  );

  const onSelectAll = useCallback(
    (isSelected) => {
      const data = {
        IdUser: sysUser.idUser,
      };

      if (isSelected) {
        setLoading(true);

        const url = `${process.env.REACT_APP_API2_URL}/User/UserLineType_AddAll`;
        axios.post(url, data).then((response) => {
          if (response.data === 0) {
            setLoading(false);
            requestUnlinkedLineTypes();
            requestLinkedLineTypes();
          }
        });
      }
    },
    [requestLinkedLineTypes, requestUnlinkedLineTypes, sysUser.idUser]
  );

  const onRowUnlinkedSelect = useCallback(
    (row, isSelected) => {
      const data = {
        IdLineType: row.idLineType,
        IdUser: sysUser.idUser,
      };

      if (isSelected) {
        setLoading(true);

        const url = `${process.env.REACT_APP_API2_URL}/User/UserLineType_Remove`;
        axios.post(url, data).then((response) => {
          if (response.data === 0) {
            setLoading(false);
            requestUnlinkedLineTypes();
            requestLinkedLineTypes();
          }
        });
      }
    },
    [requestLinkedLineTypes, requestUnlinkedLineTypes, sysUser.idUser]
  );

  const onUnlinkedSelectAll = useCallback(
    (isSelected) => {
      const data = {
        IdUser: sysUser.idUser,
      };

      if (isSelected) {
        setLoading(true);

        const url = `${process.env.REACT_APP_API2_URL}/User/UserLineType_RemoveAll`;
        axios.post(url, data).then((response) => {
          if (response.data === 0) {
            setLoading(false);
            requestUnlinkedLineTypes();
            requestLinkedLineTypes();
          }
        });
      }
    },
    [requestLinkedLineTypes, requestUnlinkedLineTypes, sysUser.idUser]
  );

  const moveFormatter = (direction, cell, row) => {
    const onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (direction) {
        onRowSelect(row, true);
      } else {
        onRowUnlinkedSelect(row, true);
      }
    };

    return (
      <button
        disabled={loading}
        onClick={onClick}
        className="relative flex items-center justify-center gap-1 p-2 overflow-hidden text-sm font-semibold leading-6 text-gray-500 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200 hover:text-black w-max h-max"
      >
        <i
          className={`fa-solid leading-3 text-center text-gray-400 font-semibold text-xs ${
            direction ? "fa-chevron-right" : "fa-chevron-left"
          }`}
        ></i>
      </button>
    );
  };

  return (
    <div className="flex flex-row items-start gap-4">
      <div className="flex flex-col items-center justify-center">
        <h3>Unassigned Line Types</h3>
        <BootstrapTable data={notLinkedLineType}>
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="idLineType"
          >
            IdLineType
          </TableHeaderColumn>
          <TableHeaderColumn
            filter={{ type: "TextFilter", delay: 1000 }}
            dataField="lineTypeName"
          >
            LineTypeName
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(cell, row) => moveFormatter(true, cell, row)} // Use the custom formatter function for the cell content
            headerAlign="center" // Center align the header
            dataAlign="center" // Center align the column content
            width="50" // Attempt to set a minimal width; adjust as necessary
          >
            <button
              disabled={loading}
              onClick={onSelectAll}
              className="relative flex items-center justify-center gap-1 p-2 overflow-hidden text-sm font-semibold leading-6 text-gray-500 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200 hover:text-black w-max h-max"
            >
              <i className="text-xs font-semibold leading-3 text-center text-gray-400 fa-solid fa-chevron-right"></i>
            </button>
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
      <div className="flex flex-col items-center justify-center">
        <h3>Assigned Line Types</h3>
        <BootstrapTable data={linkedLineType}>
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="idLineType"
          >
            IdLineType
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(cell, row) => moveFormatter(false, cell, row)} // Use the custom formatter function for the cell content
            headerAlign="center" // Center align the header
            dataAlign="center" // Center align the column content
            width="50" // Attempt to set a minimal width; adjust as necessary
          >
            <button
              disabled={loading}
              onClick={onUnlinkedSelectAll}
              className="relative flex items-center justify-center gap-1 p-2 overflow-hidden text-sm font-semibold leading-6 text-gray-500 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200 hover:text-black w-max h-max"
            >
              <i className="text-xs font-semibold leading-3 text-center text-gray-400 fa-solid fa-chevron-left"></i>
            </button>
          </TableHeaderColumn>
          <TableHeaderColumn
            filter={{ type: "TextFilter", delay: 1000 }}
            dataField="lineTypeName"
          >
            LineTypeName
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    </div>
  );
}
